import {
    SHOW_RESTAURANT_MODAL,
    HIDE_RESTAURANT_MODAL,
    DELETE_BRANCH
} from './restaurantDetails.actionsTypes';

export const showRestaurantModal = (restaurant) => {
    return  {
        type: SHOW_RESTAURANT_MODAL,
        restaurant
    };
};

export const hideRestaurantModal = () => {
    return  {
        type: HIDE_RESTAURANT_MODAL
    };
};

export const deleteBranch = (branchId) => {
    return {
        type: DELETE_BRANCH,
        branchId
    }
};